module.exports = __webpack_public_path__ + "static/crook_of_rao-cda309507445e47edcd6eae86ec93448.png";